export enum ActivityMediaResolutionEnum {
  HP_CARD = 'HP_CARD',
  CARD = 'CARD',
  LARGE_CARD = 'LARGE_CARD',
  LARGE = 'LARGE',
  ICON = 'ICON',
}

export enum OrganizationMediaResolutionEnum {
  LOGO = 'LOGO',
}
